import React from 'react';
export function PackSelector({
  config,
  selectedPack,
  onPackSelect
}) {
  const packOptions = [{
    id: 'single',
    title: '1 Pack',
    subtitle: 'Try it',
    count: '12 patches',
    price: config.pricing.singlePack,
    originalPrice: config.pricing.singlePackOriginal,
    savings: Math.round((config.pricing.singlePackOriginal - config.pricing.singlePack) / config.pricing.singlePackOriginal * 100),
    perDay: (config.pricing.singlePack / 12).toFixed(2)
  }, {
    id: 'twoGetOne',
    title: 'Buy 2 Get 1 FREE',
    subtitle: 'Most Popular',
    count: '36 patches',
    price: config.pricing.twoGetOne,
    originalPrice: config.pricing.singlePack * 3,
    savings: Math.round((config.pricing.singlePack * 3 - config.pricing.twoGetOne) / (config.pricing.singlePack * 3) * 100),
    perDay: (config.pricing.twoGetOne / 36).toFixed(2),
    highlight: true
  }, {
    id: 'threeGetTwo',
    title: 'Buy 3 Get 2 FREE',
    subtitle: 'Best Value',
    count: '60 patches',
    price: config.pricing.threeGetTwo,
    originalPrice: config.pricing.singlePack * 5,
    savings: Math.round((config.pricing.singlePack * 5 - config.pricing.threeGetTwo) / (config.pricing.singlePack * 5) * 100),
    perDay: (config.pricing.threeGetTwo / 60).toFixed(2)
  }];
  const selectedOption = packOptions.find(option => option.id === selectedPack) || packOptions[1];
  return <div data-id="element-267">
      <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-268">
        {packOptions.map(option => <button key={option.id} onClick={() => onPackSelect(option.id)} className={`p-3 rounded-lg text-center border-2 transition-all ${selectedPack === option.id ? 'border-[#0E6B6B] bg-white shadow-md' : 'border-gray-200 bg-white hover:border-[#35A67E]'} ${option.highlight ? 'relative' : ''} ${option.id === 'threeGetTwo' ? 'relative' : ''}`} data-id="element-269">
            {option.highlight && <span className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-[#E6B17E] text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-270">
                Most Popular
              </span>}
            {option.id === 'threeGetTwo' && <span className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-[#0E6B6B] text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-271">
                Best Value
              </span>}
            <div className="font-bold" data-id="element-272">{option.title}</div>
            <div className="text-sm" data-id="element-273">{option.count}</div>
            {option.savings && <div className="text-[#35A67E] text-sm font-medium" data-id="element-274">
                Save {option.savings}%
              </div>}
          </button>)}
      </div>
      <div className="flex justify-between items-baseline mb-2" data-id="element-275">
        <div className="text-2xl font-bold" data-id="element-276">
          ${selectedOption.price.toFixed(2)}
        </div>
        {selectedOption.savings && <div className="text-[#35A67E]" data-id="element-277">
            <span className="line-through text-gray-400 mr-1" data-id="element-278">
              ${selectedOption.originalPrice.toFixed(2)}
            </span>
            Save {selectedOption.savings}%
          </div>}
      </div>
      <div className="text-sm text-gray-600 mb-2" data-id="element-279">
        12 patches per pack = 6 days if using one per knee daily.
        <br data-id="element-280" />
        Just ${selectedOption.perDay}/day per knee.
      </div>
      <div className="text-sm font-medium text-[#35A67E] mb-4" data-id="element-281">
        FREE SHIPPING on all orders!
      </div>
    </div>;
}